import React from 'react';

import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

const FREE_MARKETING_TEXTS = 2000;

const SuperchargedList = () => {
  const { t } = useTranslation();

  return (
    <ul>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>
        {S.heart}
        {t('staffAndBusiness.subAndBilling.pricePlan.comingSoon')}
      </li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{t('staffAndBusiness.subAndBilling.pricePlan.unlimitedDevicesLogins')}</li>
      <li>{S.markV}</li>
      <li>
        {S.markV} {t('staffAndBusiness.subAndBilling.pricePlan.onePerMonth')}
      </li>
      <li>
        {S.markV} {t('staffAndBusiness.subAndBilling.pricePlan.unlimited')}
      </li>
      <li>
        {S.markV} {t('staffAndBusiness.subAndBilling.pricePlan.unlimited')}
      </li>
      <li>{FREE_MARKETING_TEXTS}</li>
    </ul>
  );
};

export default SuperchargedList;
